import React from 'react';

import { Link as NavLink } from '~/lib/react-router-dom';

import { Link } from '@mui/material';

const ORDER_IN_COMMENT_PATTERN = /Order:\s*([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi;

export function commentContainsOrderId(comment: string | undefined | null, orderId: string): boolean {
  if (!comment || !orderId) {
    return false;
  }

  return comment.includes(`Order: ${orderId}`);
}

export function CreditCommentText({ comment }: { comment: string }) {
  if (!comment) {
    return null;
  }

  const parts: Array<React.ReactNode> = [];
  let lastIndex = 0;
  const regex = new RegExp(ORDER_IN_COMMENT_PATTERN.source, 'gi');
  let match: RegExpExecArray | null;

  while ((match = regex.exec(comment)) !== null) {
    if (match.index > lastIndex) {
      parts.push(comment.slice(lastIndex, match.index));
    }

    parts.push('Order: ');
    parts.push(
      <Link key={`${match[1]}-${match.index}`} component={NavLink} to={`/purchases/${match[1]}`}>
        {match[1]}
      </Link>,
    );
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < comment.length) {
    parts.push(comment.slice(lastIndex));
  }

  return <>{parts}</>;
}
